import { Redirect } from "@-/com.npmjs.expo-router";
import { useIsFocused } from "@-/com.npmjs.expo-router/react-navigation";
import { useSlideLessonPageNavigator } from "@-/dev.improve.haniverse.routes.nav.app.learn.lesson.slide.index.navigator";
import { LEARN_SUMMARY_WELCOME_SLIDE_SLUG } from "@-/dev.improve.haniverse.routes.nav.app.learn.summary.navigator";

/**
 * Open the authored welcome in the same persistent, swipeable deck as every other slide, once the
 * summary is the screen (`isActive`): beneath Learn's map it waits for the learner to come to the
 * cards.
 */
export function LearnSummaryWelcomeView({ isActive = true }: { isActive?: boolean }) {
  const slidePageNavigator = useSlideLessonPageNavigator();
  const focused = useIsFocused();

  // Slides have no blocking prefetch queries. Opening the card does not complete it;
  // the deck persists completion only when the learner swipes or presses Next.
  return focused && isActive ? (
    <Redirect
      href={slidePageNavigator.resolveHref({ slideSlug: LEARN_SUMMARY_WELCOME_SLIDE_SLUG })}
    />
  ) : null;
}
